import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'formik';
import PhoneField from './PhoneField';

const FormikPhoneField = ({
  field: { name, value },
  form: { errors, setFieldValue },
  id,
  label,
  required,
  className,
  onChange,
  disabled,
  ...rest
}) => {
  const hasError = Boolean(getIn(errors, name));
  const errorText = getIn(errors, name);

  return (
    <PhoneField
      label={label}
      required={required}
      name={name}
      value={value}
      onChange={(newValue, country) => {
        const correctValue = newValue?.length > 4 ? newValue : '';
        setFieldValue(name, correctValue);
        onChange(correctValue, country);
      }}
      hasError={hasError}
      errorText={errorText}
      className={className}
      {...rest}
    />
  );
};

FormikPhoneField.propTypes = {
  onChange: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

FormikPhoneField.defaultProps = {
  onChange: () => {},
  required: false,
  disabled: false,
  className: '',
};

export default FormikPhoneField;
